var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellConcierge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280 145.324V112H296C309.255 112 320 101.255 320 88V88C320 74.745 309.255 64 296 64H216C202.745 64 192 74.745 192 88V88C192 101.255 202.745 112 216 112H232V145.324C119.582 157.307 32 252.4 32 368H480C480 252.4 392.418 157.307 280 145.324ZM488 400H24C10.745 400 0 410.745 0 424V424C0 437.255 10.745 448 24 448H488C501.255 448 512 437.255 512 424V424C512 410.745 501.255 400 488 400Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellConcierge);
export default __webpack_public_path__ + "static/media/bell-concierge.04091e05320a6ea4071b631d264417bc.svg";
export { ForwardRef as ReactComponent };